import React from 'react'
import {
  GraphOuterWrapper,
  GraphInnerWrapper,
  Graph,
} from '../style'
import BrandImageryRowNew from '../BrandImageryRowNew/BrandImageryRowNew'
import GraphScaleWrapperComponent from '../GraphScaleWrapperComponent/GraphScaleWrapperComponent'
import { ProgressionFilters } from '../../../../../components'

const Tab1Content = ({
  rows,
  canMove,
  showExpandAllCTA,
  editTitleFlag,
  editTitleClicked,
  showLevel2Func,
  showTabContent,
  progressionDataL1Filtered,
  progressionDataFiltered,
  filterChangeFunc,
  isExportToPptWithProgression,
  onChange,
}) => {

  return (
    <GraphOuterWrapper>
      <GraphInnerWrapper className='sticky'>
        {rows?.length > 0 && progressionDataL1Filtered?.drivers?.length > 0 && (
          <ProgressionFilters
            data={progressionDataL1Filtered}
            onChange={filterChangeFunc}
          />
        )}
      </GraphInnerWrapper>
      <GraphInnerWrapper className='GraphScaleWrapper'>
        <Graph simulator={canMove ? 'yes' : 'no'}>
          {progressionDataFiltered.brands.length > 0 &&
            progressionDataFiltered.drivers.length > 0 &&
            progressionDataFiltered.periods.length > 0 &&
            rows.map((rowData, index) => {
              return (
                <BrandImageryRowNew
                  isExportToPptWithProgression={isExportToPptWithProgression}
                  showExpandAllCTA={showExpandAllCTA}
                  canMove={canMove}
                  key={index}
                  index={index}
                  onChange={onChange}
                  row={rowData}
                  editTitleFlag={editTitleFlag}
                  editTitleClicked={editTitleClicked}
                  showLevel2Func={showLevel2Func}
                  showTabContent={showTabContent}
                  progressionDataFiltered={progressionDataFiltered}
                  totalPeriods={[...progressionDataFiltered.periods]}
                />
              )
            })}
        </Graph>
      </GraphInnerWrapper> 
      {/* <GraphScaleWrapperComponent /> */}
    </GraphOuterWrapper>
  )
}

export default Tab1Content
